module.exports = {"transport":"http","websocket":"wss://gtg.steem.house:8090","uri":"https://api.hive.blog","url":"","dev_uri":"https://anyx.io","stage_uri":"https://anyx.io","address_prefix":"STM","chain_id":"0000000000000000000000000000000000000000000000000000000000000000"}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 82
// module chunks = 0 1